var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-box"},_vm._l((_vm.tagList),function(item,index){return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
      content: _vm.getHtml(item),
      html: true,
      popperClass: 'tag-item-tooltip',
      disabled: _vm.type !== 5,
      triggers: ['hover', 'focus', 'touch'],
    }),expression:"{\n      content: getHtml(item),\n      html: true,\n      popperClass: 'tag-item-tooltip',\n      disabled: type !== 5,\n      triggers: ['hover', 'focus', 'touch'],\n    }"}],key:index,staticClass:"tag-item",class:_vm.showClose ? 'tag-item-close' : ''},[_c('div',{staticClass:"van-ellipsis"},[_vm._v(_vm._s(item.name))]),(_vm.showClose)?_c('div',{staticClass:"close-box",on:{"click":function($event){return _vm.remove(item.id)}}},[_c('van-icon',{attrs:{"name":"cross"}})],1):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }